export default __webpack_public_path__ + "static/media/D016.6bd80bed.jpg";